'use strict';

import gql from 'graphql-tag';

export const listMenu = gql`
  query {
    listMenu {
      __typename
      id
      title
      price
    }
  }
`;

export const orderByDate = gql`
  query orderListByDate($date: String!) {
    orderListByDate(todayDate: $date) {
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
      date
    }
  }
`;

export const searchUser = gql`
  query searchUser($search: String!) {
    searchUser(search: $search) {
      id
      email
      name
    }
  }
`;

export const searchItem = gql`
  query searchItem($search: String!) {
    searchItem(search: $search) {
      __typename
      id
      title
      price
    }
  }
`;

export const orderListByFilter = gql`
  query orderListByFilter($frmDate: String!,$userId: String, $toDate: String) {
    orderListByFilter(frmDate: $frmDate, userId: $userId, toDate: $toDate) {
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
      date
    }
  }
`;

export const userOrder = gql`
  query userOrder($id: String!) {
    userOrder(id: $id) {
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
      date
    }
  }
`;

export const userDateOrder = gql`
  query userTodayOrder($id: ID!, $date: String!) {
    userTodayOrder(id: $id, date: $date) {
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
      date
    }
  }
`;

export const getOrder = gql`
  query getOrder($id: String!) {
    getOrder(id: $id) {
      id
      quantity
      note
      date
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
    }
  }
`;

export const getMenuById = gql`
  query menuItem($id: ID!) {
    menuItem(id: $id) {
      id
      title
      price
    }
  }
`;

export const deleteMenu = gql`
  mutation deleteMenuItem($id: ID!) {
    deleteMenuItem(id: $id) {
      __typename
      id
      title
      price
    }
  }
`;

export const deleteOrderItemByMenu = gql`
  mutation deleteOrderItemByMenu($id: String!) {
    deleteOrderItemByMenu(id: $id) {
      __typename
      id
    }
  }
`;

export const addMenu = gql`
  mutation addMenuItem($id: String!, $title: String!, $price: Float!) {
    addMenuItem(input: { _id: $id, title: $title, price: $price }) {
      __typename
      id
      title
      price
    }
  }
`;

export const updateMenu = gql`
  mutation editMenuItem($id: String!, $title: String!, $price: Float!) {
    editMenuItem(input: { _id: $id, title: $title, price: $price }) {
      __typename
      id
      title
      price
    }
  }
`;

export const addUser = gql`
  mutation signup($obj: userInput) {
    signup(obj: $obj)
  }
`;

export const updateUser = gql`
  mutation signup($obj: userInput) {
    addUser(obj: $obj)
  }
`;

export const login = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password)
  }
`;

export const addOrder = gql`
  mutation addOrder(
    $id: String!
    $menuItemId: String!
    $userId: String
    $userName: String
    $quantity: Float!
    $date: String!
    $note: String
    $packing: Boolean
  ) {
    addOrder(
      input: {
        _id: $id
        menuItemId: $menuItemId
        userId: $userId
        userName: $userName
        quantity: $quantity
        date: $date
        note: $note
        packing: $packing
      }
    ) {
      __typename
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      date
      userName
    }
  }
`;

export const editOrderItem = gql`
  mutation editOrderItem(
    $id: String!
    $menuItemId: String!
    $userId: String
    $userName: String
    $quantity: Float!
    $date: String!
    $note: String
    $packing: Boolean
  ) {
    editOrderItem(
      input: {
        _id: $id
        menuItemId: $menuItemId
        userId: $userId
        userName: $userName
        quantity: $quantity
        date: $date
        note: $note
        packing: $packing
      }
    ) {
      __typename
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
      date
    }
  }
`;

export const deleteOrderItem = gql`
  mutation deleteOrderItem($id: ID!) {
    deleteOrderItem(id: $id) {
      __typename
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
      date
    }
  }
`;

export const userInfo = gql`
  query user($id: ID!) {
    user(id: $id) {
      email
      firstname
      lastname
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/global-query.ts